export const GAME_MODES = {
  'solo-fpp': 'Solo FPP',
  'duo-fpp': 'Duo FPP',
  solo: 'Solo TPP',
  duo: 'Duo TPP',
  'squad-fpp': 'Squad FPP',
  squad: 'Squad TPP',
  tdm: 'Death Match'
};
